<style lang="scss" src='./Banner.scss' scoped></style>
<template src="./Banner.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from "vuex";
  export default {
    name: 'Banner',
    props: {
      img: ''
    },
    components: {},
    data() {
      return {};
    },
    computed: {},

    methods: {},
    beforeCreate() {},
    created() {},
    mounted() {},
    beforeDestroy() {},
  };

</script>
